import { Query } from 'acast-reactor';
import request from 'superagent';
import { getUserToken } from 'services/authentication';
import Config from 'app/config';

const API_BASE = '/api-v2';

function updateShow(show) {
  return new Promise((resolve, reject) => {
    request
      .patch(`${Config.get('CREATE_API_HOST')}${API_BASE}/channels/${show.id}`)
      .send(show)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .end((err, res) => {
        if (err || !res.ok) {
          reject(res);
        } else {
          resolve(res.body);
        }
      });
  });
}

export default Query.define('show/update', updateShow);
